import { baseUrl } from "../const/base-url";

export type Category = {
  _id: number;
  name: string;
};

export async function fetchCategories(): Promise<Category[]> {
  const res = await fetch(baseUrl + "/api/categories");

  if (!res.ok) {
    throw new Error("Ошибка загрузки категорий");
  }

  return res.json();
}
